export default "__VITE_ASSET__C5B5CEOX__"